import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, Icon } from 'antd';

const mainMenu = () => {
	const itemsArray = [
		{
			name: 'File Manager',
			customNode: (
				<Menu.Item key="main-menu__item__file-manager">
					<Link className="main-menu__item__link" to="/">
						<Icon type="profile" />
						File Manager
					</Link>
				</Menu.Item>
			)
		},
		{
			name: 'Domains parser',
			customNode: (
				<Menu.Item key="main-menu__item__domains-parser">
					<Link className="main-menu__item__link" to="/domains-parser">
						<Icon type="thunderbolt" />
						Domains parser
					</Link>
				</Menu.Item>
			)
		},
		{
			name: 'Domains checker',
			customNode: (
				<Menu.Item key="main-menu__item__domains-checker">
					<Link className="main-menu__item__link" to="/domains-checker">
						<Icon type="funnel-plot" />
						Domains checker
					</Link>
				</Menu.Item>
			)
		},
		{
			name: 'Search domains and webarch',
			customNode: (
				<Menu.Item key="main-menu__item__search-domain">
					<Link className="main-menu__item__link" to="/search-domain">
						<Icon type="search" />
						Search domains and webarch
					</Link>
				</Menu.Item>
			)
		},
		{
			name: 'Auto purchase',
			customNode: (
				<Menu.Item key="main-menu__item__auto-purchase">
					<Link className="main-menu__item__link" to="/auto-purchase">
						<Icon type="wallet" />
						Auto purchase
					</Link>
				</Menu.Item>
			)
		},
		{
			name: 'Auto poster',
			customNode: (
				<Menu.Item key="main-menu__auto-poster">
					<Link className="main-menu__item__link" to="/auto-poster">
						<Icon type="database" />
						Auto poster
					</Link>
				</Menu.Item>
			)
		},
		{
			name: 'Ping',
			customNode: (
				<Menu.Item key="main-menu__item__ping">
					<Link className="main-menu__item__link" to="/ping">
						<Icon type="exclamation" />
						Ping
					</Link>
				</Menu.Item>
			)
		},
		{
			name: 'Index checker',
			customNode: (
				<Menu.Item key="main-menu__item__indexChecker">
					<Link className="main-menu__item__link" to="/index-checker">
						<Icon type="bug" />
						Index checker
					</Link>
				</Menu.Item>
			)
		},
		{
			name: 'Template generator',
			customNode: (
				<Menu.Item key="main-menu__item__tempalte-generator">
					<Link className="main-menu__item__link" to="/template-generator">
						<Icon type="file-image" />
						Template Generator
					</Link>
				</Menu.Item>
			)
		},
		{
			name: 'Change IP',
			customNode: (
				<Menu.Item key="main-menu__item__change-ip">
					<Link className="main-menu__item__link" to="/change-ip">
						<Icon type="edit" />
						Change IP
					</Link>
				</Menu.Item>
			)
		}
	];

	return (
		<div>
			<Menu mode="horizontal" selectable={false} className="main-menu">
				{itemsArray.map((listItem) => listItem.customNode)}
			</Menu>
		</div>
	);
};

export default mainMenu;
